(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["leedin-pincode"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leedin-pincode')) {
    class LeedinPincode extends HTMLElement {
      static cache = new Map();
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.sequence = 0;
        this.input = this.querySelector('input');
        this.button = this.querySelector('button');
        this.result = this.querySelector('.leedin-pin__result');
        this.status = this.querySelector('[data-pin-status]');
        this.location = this.querySelector('[data-pin-location]');
        this.areas = this.querySelector('[data-pin-areas]');
        this.button.addEventListener('click', () => this.check());
        this.input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') { event.preventDefault(); event.stopPropagation(); this.check(); }
        });
        this.input.addEventListener('input', () => {
          this.sequence++;
          this.controller?.abort();
          this.button.disabled = false;
          this.result.removeAttribute('aria-busy');
          this.input.removeAttribute('aria-invalid');
          this.clear();
        });
      }
      disconnectedCallback() {
        this.sequence++;
        this.controller?.abort();
        this.button.disabled = false;
        this.result.removeAttribute('aria-busy');
        this.clear();
      }
      clear() {
        this.status.textContent = '';
        this.location.textContent = '';
        this.areas.textContent = '';
        this.result.dataset.state = '';
      }
      message(key, state = 'error') {
        this.status.textContent = this.dataset[key];
        this.result.dataset.state = state;
      }
      show(offices, pin) {
        this.message('found', 'success');
        const clean = value => typeof value === 'string' ? value.trim() : '';
        const regions = [...new Set(offices.map(office => [clean(office.district), clean(office.state)].filter(Boolean).join(', ')).filter(Boolean))];
        const areas = [...new Set(offices.map(office => clean(office.office_name).replace(/\s+(?:B\.?\s*O\.?|S\.?\s*O\.?|H\.?\s*O\.?)$/i, '')).filter(Boolean))];
        this.location.textContent = [pin, regions.join(' / ')].filter(Boolean).join(' · ');
        this.areas.textContent = areas.join(', ');
      }
      async check() {
        if (this.button.disabled) return;
        const pin = this.input.value.trim();
        this.clear();
        if (!/^[1-9][0-9]{5}$/.test(pin)) {
          this.input.setAttribute('aria-invalid', 'true');
          this.message('invalid');
          this.input.focus();
          return;
        }
        this.input.removeAttribute('aria-invalid');
        const cached = LeedinPincode.cache.get(pin);
        if (cached && Date.now() - cached.time < 3600000) { this.show(cached.offices, pin); return; }
        if (Date.now() < (this.nextRequest || 0)) { this.message('limited'); return; }
        this.nextRequest = Date.now() + 2000;
        const request = ++this.sequence;
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        const timer = setTimeout(() => controller.abort(), 10000);
        this.button.disabled = true;
        this.result.setAttribute('aria-busy', 'true');
        this.message('loading', 'neutral');
        try {
          const response = await fetch('https://api.pincodeapi.in/api/v1/pincode/' + pin, { signal: controller.signal, credentials: 'omit', referrerPolicy: 'no-referrer' });
          if (request !== this.sequence) return;
          if (response.status === 429) { this.nextRequest = Date.now() + 10000; this.message('limited'); return; }
          if (response.status === 404) { this.message('missing'); return; }
          if (!response.ok) throw new Error('Lookup unavailable');
          const payload = await response.json();
          if (request !== this.sequence) return;
          if (payload.success !== true || !Array.isArray(payload.data?.post_offices)) throw new Error('Unexpected response');
          const matches = payload.data.post_offices.filter(office => String(office.pincode) === pin);
          if (!matches.length) {
            if (payload.data.post_offices.length) throw new Error('Unexpected records');
            this.message('missing');
            return;
          }
          if (LeedinPincode.cache.size >= 50) LeedinPincode.cache.delete(LeedinPincode.cache.keys().next().value);
          LeedinPincode.cache.set(pin, {time: Date.now(), offices: matches});
          this.show(matches, pin);
        } catch (error) {
          if (request === this.sequence) this.message('error');
        } finally {
          clearTimeout(timer);
          if (request === this.sequence) { this.button.disabled = false; this.result.removeAttribute('aria-busy'); }
        }
      }
    }
    customElements.define('leedin-pincode', LeedinPincode);
  }
  } catch(e) { console.error(e); }
})();

})();
